import React from 'react';

import type { Props } from './types';

export default function LiteCrmMapListItem({
  isSelected,
  record,
  subtitleKey = 'summary',
  onClick,
  onSelectionToggle,
  ...props
}: Props) {
  return (
    <div className="d-flex p-2 border-bottom bg-white map-list__item--lite-crm" {...props}>
      <div className="d-flex align-items-center px-2">
        <input
          checked={isSelected}
          className="form-check-input"
          type="checkbox"
          onChange={onSelectionToggle}
        />
      </div>
      <div>
        <a className="clickable" onClick={onClick}>
          {record.displayName}
        </a>
        <div className="text-muted fs-small text-truncate">
          {record[subtitleKey]}
        </div>
      </div>
    </div>
  );
}
